import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

// interface CalenderProps {
//     showYearDropdown?: boolean;
//     showMonthDropdown?: boolean;
//     selected?: any;
//     dateFormat?: string;
//     placeholderText?: string;
//     onChange?: (date: Date | [Date | null, Date | null] | null) => void;
//     showTimeInput?: boolean;
//     timeInputLabel?: string;
//     customInput?: React.ReactNode;
//     readOnly?: boolean;
//     maxDate?: Date;
//     minDate?: Date;
//     minTime?: Date;
//     maxTime?: Date;
//     showTimeSelect?: boolean;
//     locale?: string;
//     timeFormat?: string;
//     timeIntervals?: number;
//     selectsRange?: any;
//     inline?: boolean;
//     isClearable?: boolean;
//     showIcon?: boolean;
//     endDate?: Date;
//     startDate?: Date;
//     label?: string; // Add custom label prop
//     openToDate?: Date; // Add openToDate prop
//     className?: string; // Add openToDate prop
// }

const Calender = ({
    showYearDropdown,
    showMonthDropdown,
    selected,
    dateFormat = 'dd/MM/yyyy',
    placeholderText = 'To Date',
    onChange,
    showTimeInput = false,
    timeInputLabel,
    customInput, 
    readOnly,
    maxDate,
    minDate,
    minTime,
    maxTime,
    showTimeSelect,
    locale,
    timeFormat,
    timeIntervals,
    selectsRange,
    endDate,
    inline,
    isClearable,
    showIcon,
    startDate,
    label = '', // Destructure label prop
    openToDate, // Destructure openToDate prop
    className,
    monthsShown,
    error
}) => {

    return (
        <div className="calender">
            <DatePicker
                className={`${className} ${error ? 'date-picker-error' : ''}`}
                selected={selected}
                showIcon={showIcon}
                calendarIconClassName={'bx bx-calendar-alt'}
                icon={"bx bx-calendar-alt"}
                toggleCalendarOnIconClick
                locale={locale}
                dateFormat={dateFormat}
                placeholderText={placeholderText}
                onChange={onChange}
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                // showYearDropdown
                showTimeInput={showTimeInput}
                timeInputLabel={timeInputLabel}
                readOnly={readOnly} 
                // customInput={customInput}
                maxDate={maxDate}
                minDate={minDate}
                minTime={minTime}
                maxTime={maxTime}
                showTimeSelect={showTimeSelect}
                timeFormat={timeFormat}
                timeIntervals={timeIntervals}
                selectsRange={selectsRange}
                // endDate={endDate}
                inline={inline}
                onKeyDown={(e) => {
                    e.preventDefault();
                }}
                isClearable={true}
                closeOnScroll={true}
                startDate={startDate}
                endDate={endDate}
                monthsShown={monthsShown}
                openToDate={openToDate} // Set the initial view of the calendar
            >
                {label && <div className="calender-label">{selected}</div>}
                
            </DatePicker>
              {error && (
                   <div style={{ color: 'red', fontSize: '12px', marginTop: '5px', fontWeight:400 }}>
                       end date is required.
                   </div>
               )}
        </div>
    );
};

export default Calender;